import { createHookActionObservable } from '@perpay-web/services/createHookActionObservable';

export const { hookActionEpic, hookAction$ } = createHookActionObservable();
